/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Thai (Thailand): th-th
 */

/**
 * Translation file for th-TH locale
 *
 * @file th.js
 * @author Mohamed yasar arabath M
 */

const th = {
  'popularChannelSlider.allChannels': 'ช่องทางทั้งหมด',
  'popularChannelSlider.recommended': 'แนะนำ',
  'hero.myetextbook.link': 'ไลบรารี',
  'hero.myetextbook.text': 'ไม่ใช่หนังสือที่ต้องการใช่ไหม เข้าถึงไลบรารีหนังสืออิเล็กทรอนิกส์',
  'hero.etextfeaturestitle': 'ค้นหาสื่อการเรียนในหนังสือเรียนอิเล็กทรอนิกส์ของคุณ',
  'hero.etextfeaturesdescription': 'หนังสือเรียนอิเล็กทรอนิกส์ของคุณมาพร้อมกับสื่อการเรียนที่ออกแบบมาเพื่อช่วยให้คุณประสบความสำเร็จ เรียนรู้ด้วยบัตรคำศัพท์และอื่นๆ อีกมากมายได้ในหนังสือเรียนอิเล็กทรอนิกส์ของคุณ',
  'aichat.title1': 'รับความช่วยเหลือจาก AI สำหรับอะไรก็ได้ที่เกี่ยวข้องกับหนังสือเรียนอิเล็กทรอนิกส์เล่มนี้',
  'aichat.chatDesc1': 'พิมพ์คำถามเพื่อเริ่มต้น',
  'subscriptiontext.isSubscribed': 'ส่วนหนึ่งของการสมัครใช้งานของคุณ',
  'subscriptiontext.nonSubscriber': 'อัปเกรดเพื่อเข้าถึงฟังก์ชันเต็มรูปแบบ',
  'topicConatiner.otherHeader': 'วิดีโอที่เกี่ยวข้องและฝึกหัด',
  'topicConatiner.exactLiteHeader': 'แนวคิดที่เกี่ยวข้องและฝึกหัด',
  'moremenu.downloadApp': 'ดาวน์โหลดแอป',
  'moremenu.downloadAppAlreadyDownload': '%Click here% เพื่อดาวน์โหลดแอปบนอุปกรณ์อื่นและลงชื่อเข้าใช้โดยอัตโนมัติ หรือใช้รหัส QR เฉพาะของคุณเพื่อลงชื่อเข้าใช้แอปที่คุณติดตั้งไว้แล้วอย่างปลอดภัย',
  'moremenu.downloadAppNotDownload': '%Click here% เพื่อดาวน์โหลดแอปและเข้าสู่ระบบอย่างปลอดภัยด้วยรหัส QR เฉพาะของคุณ',
  'channel.noBundletitle': 'ใช้ Study Prep สำหรับหลักสูตรที่เกี่ยวข้องและอื่นๆ ของคุณ',
  'onboard.studyPlan': 'สร้างแผนการเรียนเฉพาะบุคคลแล้ว!',
  'onboard.addCourseAnother': 'คุณต้องการเพิ่มหลักสูตรอื่นหรือไม่',
  'onboard.purchase': 'ฉันต้องการซื้อหนังสือเรียนอิเล็กทรอนิกส์ของ Pearson',
  'onboard.addCourseWithoutEtext': 'เพิ่มหลักสูตรโดยใช้ Study Prep',
  'onboard.mayBeLater': 'อาจจะในภายหลัง',
  'onboard.aboutCourse': 'บอกเราเกี่ยวกับหลักสูตรของคุณ',
  'onboard.close': 'ปิด',
  'course.addTitle': 'เพิ่มหลักสูตร',
  'common.PURCHASE': 'ซื้อ',
  'common.CLOSE': 'ปิด',
  'open': 'เปิด',
  'continue': 'ดำเนินการต่อ',
  'yes': 'ใช่',
  'no': 'ไม่ใช่',
  'audio': 'เสียง',
  'courses.toc.PUBLISH_SUCCESS': 'สำเร็จ!',
  'courses.toc.PUBLISH_MESSAGE': 'นักเรียนจะเห็นการเปลี่ยนแปลงของคุณในครั้งต่อไปที่พวกเขาเปิดเนื้อหา',
  'errors.GENERIC_TITLE': 'คุณไม่มีสิทธิ์เข้าถึงในขณะนี้',
  'errors.GENERIC_DESC': 'ขั้นแรก ให้รีเฟรชหรือล้างแคชของคุณ หากยังไม่สามารถแก้ไขได้ โปรดติดต่อฝ่ายสนับสนุน ',
  'errors.GENERIC_LINK': 'ของ Pearson',
  'errors.GENERIC_CODE': 'รหัสข้อผิดพลาด: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'ไม่พบการสมัครใช้งาน',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'บัญชีของคุณไม่มีสิทธิ์เข้าถึงหนังสือเล่มนี้ หากคุณคิดว่าได้รับข้อความนี้โดยไม่ถูกต้อง โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของ Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'ไม่พบการสมัครใช้งาน',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'การสมัครใช้งานของคุณไม่รวมถึงการเข้าถึงหนังสือเรียนอิเล็กทรอนิกส์ แต่คุณสามารถสมัครใช้งานได้ทันทีโดยใช้บัตรเครดิต',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'บัญชีของฉัน',
  'menu.helpCenter': 'ศูนย์ความช่วยเหลือ',
  'menu.preferencesCenter': 'ศูนย์ความต้องการ',
  'menu.CONTACT_SUPPORT': 'ติดต่อฝ่ายสนับสนุน',
  'menu.HELP_SUPPORT': 'ความช่วยเหลือและการสนับสนุน',
  'menu.FAQS': 'คำถามที่พบบ่อย',
  'menu.CHAT_WITH_SUPPORT': 'แชทกับฝ่ายสนับสนุน',
  'menu.OTP_CODES': 'รหัส OTP',
  'menu.LAUNCH_CODE': 'เปิดบันทึกรหัส',
  'menu.SEND_CODE': 'ส่งรหัสใหม่ถึงผู้ใช้ผ่านอีเมล',
  'menu.SEND_CODE_PHONE': 'ส่งรหัสใหม่ถึงผู้ใช้ผ่านข้อความ',
  'menu.LEGAL': 'ข้อมูลทางกฎหมาย',
  'menu.PRIVACY_NOTICE': 'ประกาศความเป็นส่วนตัว',
  'menu.TITLE_INFO': 'ข้อมูลหนังสือ',
  'menu.PEARSON_ACCESSIBILITY': 'ตัวช่วยการเข้าถึง Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'ลงทะเบียนได้ {deviceLimit} อุปกรณ์ เปลี่ยนได้เดือนละ 1 อุปกรณ์',
  'menu.ACCESSIBILITY': 'ตัวช่วยการเข้าถึง',
  'menu.ACCESSIBILITY_SUPPORT': 'การสนับสนุนตัวช่วยการเข้าถึง',
  'menu.DEVICES': 'อุปกรณ์ล่าสุด',
  'menu.THIS_DEVICE': 'อุปกรณ์นี้',
  'menu.GET_THE_APP_DOWNLOAD': 'ดาวน์โหลดแอปมือถือ',
  'menu.MOJO_APP_INFO': 'ไปที่แอปสโตร์บนโทรศัพท์หรือแท็บเล็ตของคุณเพื่อใช้งาน Pearson+ แบบออฟไลน์',
  'menu.DEVICE_LABEL': 'อุปกรณ์',
  'menu.DEVICE_DISCONNECT': 'ตัดการเชื่อมต่อ',
  'menu.FOXIT': 'ขับเคลื่อนโดย FoxIT',
  'menu.TERMS_OF_USE': 'ข้อกำหนดในการใช้งาน',
  'menu.SIGN_OUT': 'ออกจากระบบ',
  'menu.PRINT_PAGE': 'พิมพ์หน้า',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': 'พิมพ์โดย {fullName}({email}) เมื่อ {currentDate}',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'คุณได้สลับแล้วในเดือนนี้',
  'device.SWITCH_DEVICE': 'เปลี่ยนไปยังอุปกรณ์ปัจจุบันหรือไม่',
  'device.SWITCH_ONCE': 'เนื่องจากคุณสามารถเปลี่ยนได้เพียงเดือนละครั้ง คุณจึงไม่สามารถยกเลิกการดำเนินการนี้ได้',
  'device.SEAT_TAKEN': 'ที่นั่งนั้นมีคนจองแล้ว',
  'device.DISCONNECT_DEVICE': 'คุณสามารถเข้าสู่ระบบได้เพียง 3 อุปกรณ์เท่านั้น หากต้องการดำเนินการต่อ โปรดตัดการเชื่อมต่ออุปกรณ์อื่นออก',
  'device.ALERT_TEXT': 'จำไว้ว่า คุณสามารถเปลี่ยนอุปกรณ์ได้เพียงเดือนละครั้งเท่านั้น',
  'device.DISCONNECT': 'ตัดการเชื่อมต่อ',
  'device.CONTINUE': 'ดำเนินการต่อ',
  'device.HEADER': 'สิ้นสุดเซสชันเบราว์เซอร์อื่นของคุณหรือไม่',
  'device.CLOSE': 'กลับไปที่หน้าหลัก',
  'device.CODE': 'ดำเนินการต่อโดยป้อนรหัสการยืนยันตัวตนที่เราส่งไปที่ {maskedEmail} หากใช้งานไม่ได้ โปรดตรวจสอบโฟลเดอร์สแปม {email} หรือติดต่อ {support}',
  'device.TIMER': 'คุณมี {time} เพื่อป้อนรหัสของคุณที่นี่',
  'device.RESEND': '{resend}',
  'device.FAQ': 'คำถามที่พบบ่อย',
  'device.RESEND_NAME': 'ส่งใหม่',
  'device.NOTE': 'หากคุณใช้งาน Pearson+ เป็นประจำใน 2 สถานที่ เช่น ที่ทำงานและที่บ้าน โปรดอย่าลืมออกจากระบบทุกครั้งหลังใช้งานเสร็จ คุณยังสามารถใช้งานแอป Pearson+ บนมือถือได้สูงสุด 2 อุปกรณ์ สำหรับข้อมูลเพิ่มเติม โปรดดูที่ {faq} ของเรา',
  'device.NOTE_HEADER': 'หลีกเลี่ยงสิ่งนี้ในครั้งต่อไป',
  'device.CONTACT_SUPPORT': 'ฝ่ายสนับสนุนลูกค้า',
  'device.CONTACT_EMAIL': 'อัปเดตอีเมลของคุณ',
  'device.INCORRECT': 'ไม่ถูกต้อง ตรวจสอบรหัสของคุณอีกครั้งหรือส่งใหม่อีกครั้ง',
  'device.MANY_ATTEMPTS': 'ทำหลายครั้งเกินไป ลองส่งรหัสใหม่',
  'device.EXPIRED': 'หมดเวลาแล้ว ลองส่งรหัสใหม่',
  'device.ACCESS_HEADER': 'คุณเข้าร่วมแล้ว!',
  'device.ACCESS_DESC': 'เซสชันของคุณได้รับการยืนยันตัวตนแล้ว ต้องการเปลี่ยนรหัสผ่านของคุณด้วยหรือไม่',
  'device.ACCESS_CHANGE_PASSWORD': 'เปลี่ยนรหัสผ่าน',
  'device.ACCESS_RESET_PASSWORD': 'รีเซ็ตรหัสผ่าน',
  'device.THREATONE_TITLE': 'ทุกอย่างดูดีใช่ไหม',
  'device.THREATONE_DESC': 'เราตรวจพบกิจกรรมที่น่าสงสัยในบัญชีของคุณ',
  'device.THREATONE_DESC_TWO': 'นี่เป็นเวลาที่เหมาะสมที่จะเปลี่ยนรหัสผ่านของคุณ',
  'device.MAY_BE_LATER': 'อาจจะในภายหลัง',
  'device.OKAY': 'โอเค',
  'device.ACCOUNT_LOCK_DESC': 'เพื่อความปลอดภัย เราได้นำคุณออกจากระบบ เราได้ส่งลิงก์สำหรับรีเซ็ตรหัสผ่านไปยังอีเมลที่เชื่อมโยงกับบัญชีของคุณแล้ว',
  'device.ACCOUNT_LOCK_TITLE': 'เราสังเกตเห็นกิจกรรมที่น่าสงสัยในบัญชีของคุณ',
  'device.ACCOUNT_LOCK_TIMER': 'คุณจะถูกนำออกจากระบบใน {time}',
  'navigation.PAGE': 'หน้า',
  'launchcode.CREATEBY': 'สร้างโดย:',
  'launchcode.sentvia': 'ส่งผ่าน:',
  'launchcode.CODEINLAST': 'รหัสในช่วง 7 วันที่ผ่านมา:',
  'launchcode.TIMESENT': 'เวลาที่ส่ง: ',
  'launchcode.ACCOUNTEMAIL': 'อีเมลของบัญชี:',
  'launchcode.LAUNCHDIALOGTITLE': 'บันทึกรหัส OTP',
  'textmessage.TITLE': 'ป้อนหมายเลขโทรศัพท์',
  'textmessage.PHONE_NUMBER': 'หมายเลขโทรศัพท์',
  'textmessage.SEND_CODE': 'ส่งรหัส',
  'textmessage.INVALID_NUMBER': 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
  'textmessage.SUCCESS_MESSAGE': 'ส่งรหัสแล้ว',
  'remove.title': 'ลบชื่อเรื่องออกหรือไม่',
  'remove.subTitle': 'คุณสามารถเรียกมันกลับมาได้เสมอในภายหลัง เพียงแค่ใช้ฟังก์ชันค้นหาเพื่อเพิ่มกลับเข้าไปใหม่',
  'remove.buttonText': 'ลบออก',
  'search.searchPlaceHolderPPlus': 'ค้นหาตามหมายเลข ISBN หนังสือ หรือผู้แต่ง',
  'search.searchPlaceHolderEText': 'ค้นหาไลบรารีของคุณ',
  'footer.downloadMobileApp': 'ดาวน์โหลดแอปมือถือ',
  'footer.termsOfUse': 'ข้อกำหนดในการใช้งาน',
  'footer.privacy': 'ความเป็นส่วนตัว',
  'footer.cookies': 'คุกกี้',
  'footer.doNotSellMyPersonalInformation': 'ห้ามขายข้อมูลส่วนบุคคลของฉัน',
  'footer.accessibility': 'ตัวช่วยการเข้าถึง',
  'footer.patentNotice': 'ประกาศสิทธิบัตร',
  'footer.copyrights': 'Pearson สงวนลิขสิทธิ์ทั้งหมด',
  'hero.toc.defaultPlacehoder': '--- เลือกหัวข้อ ---',
  'hero.openEtextBookV1': 'เปิดหนังสือเรียนอิเล็กทรอนิกส์',
  'hero.heroHeading': 'เนื่องจากคุณกำลังเรียน <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Study Prep',
  'hero.study.help': 'รับความช่วยเหลือในการเรียน',
  'hero.study.jumpBackIn': 'กลับเข้าไปใหม่ใน',
  'hero.study.numOfUsers': 'ขณะนี้มีนักเรียน <b>{num_of_users}</b> คนที่ใช้ช่องทาง',
  'hero.heroChannel.cardsHeading': 'ดำเนินการต่อจากจุดที่คุณออกไป',
  'hero.marketingcard1.copy.title': 'เรียนรู้ด้วยวิดีโอ',
  'hero.marketingcard1.copy.description': 'ดูวิดีโอขนาดสั้นที่อธิบายหัวข้อที่ซับซ้อนให้เข้าใจง่าย',
  'hero.marketingcard2.copy.title': 'ปัญหาฝึกหัด',
  'hero.marketingcard2.copy.description': 'เตรียมตัวสอบของคุณด้วยแบบฝึกหัดที่เหมือนสอบจริงหลายพันข้อ พร้อมวิดีโอเฉลย',
  'hero.marketingcard3.copy.title': 'รับความช่วยเหลือจากผู้มีประสบการณ์',
  'hero.marketingcard3.copy.description': 'โพสต์คำถามและรับคำตอบจากผู้เชี่ยวชาญในสาขาต่างๆ',
  'hero.popularTopics.heading': 'หัวข้ออื่นๆ ที่ได้รับความนิยมในช่องทางนี้',
  'hero.popularChannels.headingv1': 'เรียนหลักสูตรอื่นหรือไม่',
  'hero.popularChannels.descriptionv2': 'เรียกดูหัวข้อในความช่วยเหลือในการเรียนยอดนิยม',
  'hero.practice': 'ฝึกหัด',
  'hero.herobook.mappedChannelHeading': 'ความช่วยเหลือในการเรียนที่แนะนำในช่องทางนี้',
  'libraryL2.myBooks': 'หนังสือของฉัน',
  'libraryL2.archived': 'เก็บถาวรแล้ว',
  'libraryL2.back': 'ย้อนกลับ',
  'hero.practiceProblem': 'ปัญหาฝึกหัด',
  'nativeAppBanner.drawer.title': 'เปิดใน ...',
  'nativeAppBanner.drawer.pearsonApp': 'แอป Pearson+',
  'nativeAppBanner.banner.title': 'แอป Pearson+',
  'nativeAppBanner.banner.description': 'เรียนรู้ในขณะเดินทาง',
  'hero.promotionalcard.list1': 'วิดีโอขนาดสั้นที่อธิบายหัวข้อที่ซับซ้อนให้เข้าใจง่าย',
  'hero.promotionalcard.list2': 'คำถามคล้ายข้อสอบหลายพันข้อ',
  'hero.promotionalcard.list3': 'รับคำตอบจากผู้เชี่ยวชาญในสาขาต่างๆ',
  'hero.studyandexamprep': 'Study Prep',
  'hero.heroBook.sectionSubHeadingV1': 'อธิบายหัวข้อที่ยากด้วยวิดีโออธิบายและแบบฝึกหัดที่ออกแบบมาให้เหมาะกับหลักสูตรของคุณ',
  'hero.heroBook.sectionSubHeadingV2': 'อธิบายแนวคิดสำคัญและฝึกทำแบบฝึกหัดที่ออกแบบมาให้เหมาะกับหลักสูตรของคุณ เพื่อให้เข้าใจหัวข้อที่ยากได้ง่ายขึ้น',
  'hero.SeeAllStudyOptions': 'ดูตัวเลือกของนักเรียนทั้งหมด',
  'hero.herobook.mappedChannelHeadingV1': 'วิดีโอที่แนะนำและคำถามฝึกหัดเพิ่มเติม',
  'hero.popularTopics.headingV1': 'หัวข้อยอดนิยมอื่นๆ',
  'hero.heroHeadingV1': 'สำหรับ <span>{replace_value}</span>',
  'hero.learnmore': 'เรียนรู้เพิ่มเติม',
  'hero.eTextbook': 'หนังสือเรียนอิเล็กทรอนิกส์',
  'hero.goToPage.label': 'ไปที่หน้า',
  'subscription.studyTitle': 'Study Prep',
  'print.printAvailTitle': 'ต้องการพิมพ์หน้านี้ใช่ไหม นี่คือวิธีการ',
  'print.printAvailDesc': 'ในหนังสือเรียนอิเล็กทรอนิกส์ของคุณ ให้เลือกไอคอนบัญชีที่มุมบนขวา จากตัวเลือก ให้เลือก "พิมพ์หน้า" แล้วเลือกการตั้งค่าการพิมพ์ของคุณ',
  'print.printNotAvailTitle': 'ไม่ได้เปิดใช้งานตัวเลือกพิมพ์สำหรับเอกสารอิเล็กทรอนิกส์นี้',
  'print.printNotAvailDesc': 'เพื่อความสะดวกในการเข้าถึงแบบออฟไลน์ โปรดดาวน์โหลดหนังสือเรียนผ่านแอปมือถือ Pearson+ และเพลิดเพลินกับความยืดหยุ่นในการเรียนได้ทุกที่ทุกเวลา!',
  'hero.header.cta': 'ไปที่เครื่องมือการเรียน',
  'hero.header.ctav2': 'เปิด Study Prep',
  'hero.marketing.title': 'ค้นหาหนังสือเรียนอิเล็กทรอนิกส์ของคุณ',
  'hero.marketing.subTitle': 'เลือกจากหนังสือเรียนอิเล็กทรอนิกส์กว่า 2,000 เล่ม พร้อมไฟล์เสียง บัตรคำศัพท์ บันทึกย่อ และอื่นๆ อีกมากมาย เพียงเดือนละ 10.99 ดอลลาร์ สำหรับระยะเวลา 4 เดือน',
  'hero.popularchannels.desc': 'รับความช่วยเหลือในการเรียนจากรายวิชายอดนิยมเหล่านี้',
  'hero.removecourse.title': 'ลบหลักสูตรออกจากแดชบอร์ดหรือไม่',
  'hero.removecourse.description': 'คุณสามารถเพิ่มหลักสูตรนี้กลับไปยังแดชบอร์ดของคุณได้เสมอโดยคลิก "เพิ่มหลักสูตร"',
  'hero.removecourse.primaryCtaText': 'ลบออก',
  'hero.removecourse.secondaryCtaText': 'ยกเลิก',
  'hero.tableOfContents': 'สารบัญ',
  'hero.search': 'ค้นหา',
  'hero.emptystate.cta': 'ค้นหาหนังสือเรียนอิเล็กทรอนิกส์',
  'hero.watch_it_again': 'ดูอีกครั้ง',
  'hero.mondly.learnLang.title': 'เรียนรู้ด้วยภาษาใหม่ได้ฟรี',
  'hero.mondly.subTitle': 'ผู้ใช้หนังสือเรียนอิเล็กทรอนิกส์ Pearson จะได้รับ Mondly โดย Pearson ฟรี 3 เดือน',
  'hero.mondly.description': 'แอปการเรียนภาษาส่วนใหญ่จะอนุญาตให้เรียนได้เฉพาะภาษาอังกฤษเท่านั้น แต่การเรียนจากภาษาแม่ของคุณนั้นดีที่สุด ดังนั้น Mondly จึงให้คุณเรียนได้จาก <strong>41 ภาษาที่เรามีให้เลือก</strong>',
  'hero.mondly.startLearningCTA': 'เริ่มการเรียนรู้',
  'hero.mondly.marketing.bestApp': 'แอปที่ดีที่สุด',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'แอปแห่งปี',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - ผู้ชนะของ EMEA ปี 2017',
  'hero.mondly.marketing.editorChoice': 'ตัวเลือกของบรรณาธิการ',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'เรียนรู้ภาษา',
  'header.menu.moreAtPearson': 'เพิ่มเติมที่ Pearson',
  'hero.subscriptionStatusTitle2': 'ทรัพยากร Pearson+ ของคุณ',
  'hero.startStudying': 'เริ่มการเรียน',
  'onboard.studyMaterials': 'เลือกหลักสูตรที่คุณสนใจ แล้วเราจะสร้างแดชบอร์ดพร้อมสื่อการเรียนที่ปรับแต่งให้เหมาะสมกับคุณ',
  'hero.myETextbooks': 'หนังสือเรียนอิเล็กทรอนิกส์ของฉัน',
  'header.continueInTheApp': 'ดำเนินการต่อในแอป',
  'hero.learnTxt': 'เรียนรู้',
  'hero.examPrepTxt': 'เตรียมพร้อมการสอบ',
  'hero.aITutorTxt': 'ติวเตอร์ AI',
  'AI.toolTip': 'ถามอะไรก็ได้เกี่ยวกับเนื้อหาในหนังสือเรียนอิเล็กทรอนิกส์ของคุณ',
  'hero.studyExamPrepAllYourCourses': 'Study Prep สำหรับทุกหลักสูครของคุณ',
  'header.qrCode.subHeaderTxt': 'ใช้รหัส QR นี้เพื่อเข้าสู่ระบบแอป Pearson+ บนอุปกรณ์มือถือของคุณอย่างรวดเร็วและปลอดภัย',
  'header.qrCode.dontHaveApp': 'ไม่มีแอปใช่ไหม',
  'header.qrCode.footerTxt': 'การสแกนรหัสนี้จะนำคุณไปยัง App Store หรือ Google Play เมื่อดาวน์โหลดแอปเสร็จแล้ว ให้ลงชื่อเข้าใช้โดยการสแกนอีกครั้ง',
  'header.qrCode.errorMsg': 'รหัส QR ไม่โหลด ปิดแล้วลองใหม่อีกครั้ง',
  'hero.yourETextbook': 'หนังสือเรียนอิเล็กทรอนิกส์ของคุณ',
  'onboard.addCourseWithEtextBundle': 'เพิ่มหลักสูตรโดยใช้ Study Prep',
  'onboard.disableTooltipText': 'เพิ่มหลักสูตร Study Prep ทั้งหมดเรียบร้อยแล้ว!',
  'subscriptionstatus.bundlecta': 'เข้าถึง Study Prep',
  'subscriptionstatus.nonbundlecta': 'เข้าถึง Study Prep',
  'channel.genericBundle': 'ใช้ Study Prep ของคุณเพื่อช่วยในการเรียนวิชาอื่นๆ',
  'channel.relatedBundle': 'นอกจากนี้ ยังสามารถใช้ Study Prep เพื่อช่วยในหลักสูตรอื่นๆ ได้อีกด้วย',
  'onboard.courseAdded': 'หลักสูตรถูกเพิ่ม!',
  'hero.flashcards': 'บัตรคำศัพท์',
  'relatedChannelCard.title': 'เพิ่มประสิทธิภาพการเรียนรู้ของคุณด้วยทรัพยากรที่เกี่ยวข้องนี้',
  'relatedChannelCard.badgeText': 'Study Prep ที่เกี่ยวข้อง',
  'sessionInactivity.title': 'คุณยังอยู่หรือไม่',
  'sessionInactivity.description': 'เซสชันของคุณจะหมดเวลาใน <b>%TIMER%</b> เนื่องจากไม่มีการใช้งาน<br/>คุณต้องการคงอยู่ในระบบต่อไปหรือไม่',
  'sessionInactivity.keepMeSignIn': 'ให้ฉันอยู่ในระบบ',
  'sessionInactivity.signOut': 'ออกจากระบบ',
  'sessionTimeout.title': 'เซสชันหมดเวลา',
  'sessionTimeout.description': 'เซสชันของคุณหมดเวลาเนื่องจากไม่มีการใช้งาน',
  'print.qrCode.header': 'ใช้รหัส QR นี้เพื่อเปิดแอป Pearson+ บนอุปกรณ์มือถือของคุณ',
  'print.qrCode.footer': 'การสแกนรหัสนี้จะนำคุณไปยัง App Store หรือ Google Play เมื่อติดตั้งแอปเสร็จแล้ว ให้ลงชื่อเข้าใช้เพื่อดาวน์โหลดและเข้าถึงเกมของคุณ',
  'hero.nestest.title': 'เตรียมตัวสำหรับการสอบรับรองคุณวุฒิครู',
  'hero.nestest.subTitle': 'ผู้ใช้งาน Pearson+ สามารถเข้าถึงหลักสูตรการเตรียมความพร้อมและแบบทดสอบฝึกหัดที่สอดคล้องกับมาตรฐานระดับประเทศ เพื่อเตรียมตัวสำหรับการสอบรับรองคุณวุฒิครูได้แล้ว',
  'hero.channelAI.title': 'ต้องการความช่วยเหลือใช่ไหม ติวเตอร์ AI ช่วยคุณได้',
  'hero.channelAI.desc': 'ถามคำถามและรับความช่วยเหลือด้านการบ้านแบบทีละขั้นตอน คำแนะนำในการเรียน และอื่นๆ อีกมากมาย — ความช่วยเหลือแบบส่วนตัวทุกครั้งที่คุณต้องการ',
  'hero.channelAI.action': 'ถามติวเตอร์ AI เลย',
  'new': 'ใหม่!',
  'hero.practice.numOfUsers': 'ส่วนนี้มี <b>{practice_num_of_users}</b> ปัญหาฝึกหัด',
  'hero.practice.cta': 'ฝึกหัดตอนนี้',
  'hero.practice.title': 'ปัญหาฝึกหัด',
  'diagnostics.errorMsg': 'ไม่สามารถโหลดการวินิจฉัยได้ ปิดแล้วลองใหม่อีกครั้ง',
  'qrcode.title': 'เริ่มการเรียนได้จากทุกที่',
  'qrcode.subtitle': 'เรียนรู้ได้ทุกที่ทุกเวลาด้วยแอปมือถือ Pearson+ ดาวน์โหลดเลยและปลดล็อกประสบการณ์การเรียนรู้ที่ราบรื่น',
  'qrcode.detailsv1': 'ด้วยแอป Pearson+ คุณสามารถใช้รหัส QR นี้้เพื่อเลือกจุดที่คุณออกไป ค้นหาหนังสือเรียน เรียนรู้ด้วยบัตรคำศัพท์ ดูบทเรียนวิดีโอ และอื่นๆ อีกมากมายได้ทุกที่ทุกเวลา',
  'qrcode.detailsv2': 'สแกนรหัส QR นี้เมื่อใดก็ตามที่คุณต้องการเข้าสู่ระบบอย่างรวดเร็วและดำเนินการต่อจากจุดที่คุณออกไป',
  'qrcode.details': 'ด้วยแอป Pearson+ คุณสามารถใช้รหัส QR นี้้เพื่อเลือกจุดที่คุณออกไป',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'เรียนรู้ได้ทุกที่ทุกเวลาด้วยแอปมือถือ Pearson+ ดาวน์โหลดเลยและปลดล็อกประสบการณ์การเรียนรู้ที่ราบรื่น',
  'install': 'Install',
  'header.menu.createCourse': 'หลักสูตรใหม่',
  'header.dropdown.courses': 'หลักสูตร',
  'header.dropdown.recentlyViewed': 'ที่ดูล่าสุด',
  'header.dropdown.viewAll': 'ดูหลักสูตรทั้งหมด',
  'aet.courseHeader.inviteStudents': 'เชิญนักเรียน',
  'aet.courseHeader.inviteStudentModal.subTitle': 'เชิญชวนนักเรียนให้เข้าถึงหนังสือเรียนอิเล็กทรอนิกส์เล่มนี้โดยคัดลอกที่อยู่ลิงก์หรือคำแนะนำด้านล่างลงในอีเมลหรือโครงร่างหลักสูตรของคุณ',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'ที่อยู่ลิงก์',
  'aet.courseHeader.inviteStudentModal.copyLink': 'คัดลอกลิงก์',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'คำแนะนำพร้อมที่อยู่ลิงก์',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'คัดลอกคำแนะนำ',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'ได้เวลาเข้าถึง {bookTitle} หนังสือเรียนอิเล็กทรอนิกส์สำหรับ {courseName} แล้ว\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'เมื่อคุณพร้อมแล้ว ให้เข้าถึงหนังสือเรียนอิเล็กทรอนิกส์ของคุณได้ที่: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'ระบบจะขอให้คุณเข้าสู่ระบบด้วยบัญชี Pearson ที่มีอยู่ของคุณ หากคุณไม่มีบัญชี Pearson คุณสามารถสร้างบัญชีใหม่ได้\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'ต้องการความช่วยเหลือหรือไม่',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'วันที่เริ่มต้น:',
  'aet.courseHeader.endDate': 'วันที่สิ้นสุด:',
  'aet.courseHeader.start': 'Start:',
  'aet.courseHeader.end': 'End:',
  'aet.courseHeader.moreOptions': 'More options',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'รูปแบบ:',
  'aet.home.manageroster': 'จัดการรายชื่อ',
  'aet.home.managegradesync': 'จัดการการซิงค์เกรด',
  'aet.home.copycourse': 'คัดลอกหลักสูตร',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',

  'aet.instructorCourse.tabs.current': 'ปัจจุบัน',
  'aet.instructorCourse.tabs.past': 'ผ่านมาแล้ว',
  'aet.instructorCourse.tabs.courseSettings': 'การตั้งค่าหลักสูตร',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'จัดการรายชื่อ',
  'aet.instructorCourse.currentCourses.title': 'หลักสูตรปัจจุบัน',
  'aet.instructorCourse.pastCourses.title': 'หลักสูตรที่ผ่านมา',
  'aet.instructorCourse.archivedCourses.title': 'Archived courses',
  'aet.instructorCourse.archivedCourses.description': 'Archived titles are hidden from Current and Past. Your access to each title doesn’t change — unarchive it any time to put it back on your bookshelf.',
  'aet.instructorCourse.archivedCourses.emptyStateTitle': 'No archived titles',
  'aet.instructorCourse.archivedCourses.emptyStateDescription': 'Archive a title from Current or Past using its ··· menu. It moves here without changing your access.',
  'aet.instructorCourse.archiveDialog.title': 'Archive title(s)',
  'aet.instructorCourse.archiveDialog.description': 'Archived titles will move to the Archived tab, and all courses that use that title will be archived. They can still be accessed from the archived section, directly from the MLM course, and from Console. You can unarchive it anytime from the Archived tab.',
  'aet.instructorCourse.archiveDialog.confirmCTA': 'Archive',
  'aet.instructorCourse.unarchiveDialog.title': 'Unarchive title(s)',
  'aet.instructorCourse.unarchiveDialog.description': 'Unarchived titles will be accessible from your home page.',
  'aet.instructorCourse.unarchiveDialog.confirmCTA': 'Unarchive',
  'aet.home.archiveCourse': 'Archive',
  'aet.home.unarchiveCourse': 'Unarchive',
  'aet.instructorCourse.createOrCopy.title': 'สร้างหรือคัดลอกหนังสือเรียนอิเล็กทรอนิกส์ Pearson',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'คัดลอกหลักสูตรของผู้สอนคนอื่นหรือสร้างรายการใหม่',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'คัดลอกหลักสูตรของผู้สอนคนอื่น',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'ป้อน ID หลักสูตรเพื่อค้นหาหลักสูตรที่คุณต้องการคัดลอก',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID หลักสูตร',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'ป้อน ID หลักสูตร',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'คุณได้ค้นหา',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'สร้างหลักสูตรใหม่จากแคตตาล็อก',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'ค้นหาตามชื่อเรื่อง ผู้แต่ง, ISBN หรือคำสำคัญของรายวิชา',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'ค้นหา...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'แสดงมากขึ้น',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'แสดงน้อยลง',
  'aet.instructorCourse.cancel': 'ยกเลิก',
  'aet.instructorCourse.loading': 'กำลังโหลด...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'การซิงค์เกรด',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'จัดการการซิงค์เกรด',
  'aet.instructorCourse.courseForm.courseNameLabel': 'ชื่อหลักสูตร',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'ไม่มีชื่อเรื่อง',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'ชื่อส่วน',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'ไม่มีชื่อเรื่อง',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'สถาบัน',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'ต้องระบุสถาบัน',
  'aet.instructorCourse.courseForm.institutionSearchError': 'เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง',
  'aet.instructorCourse.courseForm.institutionNoResults': 'ไม่พบผลลัพธ์',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.startDateLabel': 'วันที่เริ่มต้นของหลักสูตร',
  'aet.instructorCourse.courseForm.endDateLabel': 'วันที่สิ้นสุดของหลักสูตร',
  'aet.instructorCourse.courseForm.datePlaceholder': 'วว/ดด/ปป',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'อนุญาตให้ผู้อื่นคัดลอกหลักสูตรนี้',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'แชร์รหัสนี้กับผู้สอนที่ต้องการคัดลอกหลักสูตรนี้',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'คัดลอกรหัส',
  'aet.instructorCourse.courseForm.optionalSuffix': '(ทางเลือก)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'แบบฟอร์มมีข้อผิดพลาดการตรวจสอบ',
  'aet.instructorCourse.courseForm.submitContinue': 'ดำเนินการต่อ',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'กำลังบันทึก...',
  'aet.instructorCourse.courseForm.submitError': 'เราไม่สามารถสร้างหลักสูตรของคุณได้ โปรดลองอีกครั้ง',
  'aet.instructorCourse.courseForm.submitEditError': 'เราไม่สามารถบันทึกหลักสูตรของคุณได้ โปรดลองอีกครั้ง',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'บันทึกการเปลี่ยนแปลง',
  'aet.instructorCourse.courseForm.materialsHeader': 'เนื้อหาของหลักสูตร',
  'aet.instructorCourse.courseForm.resolveError': 'เราไม่สามารถโหลดเนื้อหาของหลักสูตรได้ โปรดลองอีกครั้ง',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'ที่ดูล่าสุด',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'ที่เพิ่มล่าสุด',
  'aet.instructorCourse.coursesSort.aToZ': 'A ไป Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z ไป A',
  'aet.instructorCourse.manageRoster.column.name': 'ชื่อ',
  'aet.instructorCourse.manageRoster.column.role': 'บทบาท',
  'aet.instructorCourse.manageRoster.column.email': 'อีเมล',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'สถานะ',
  'aet.instructorCourse.manageRoster.column.statusInfoTooltip': 'Status information',
  'aet.instructorCourse.manageRoster.statusInfoModal.title': 'Status',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph1': 'This status reflects Pearson enrollment and may not match a student\'s enrollment status in your linked LMS course.',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph2': 'Students marked as Inactive will not have grades synced back to the LMS.',
  'aet.instructorCourse.manageRoster.access.tempAccessTitle': 'Temporary access',
  'aet.instructorCourse.manageRoster.access.active': 'Active eTextbook access',
  'aet.instructorCourse.manageRoster.access.endsOn': 'Ends: {date}',
  'aet.instructorCourse.manageRoster.access.ended': 'Ended:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.roster.role.student': 'นักเรียน',
  'aet.instructorCourse.roster.role.ta': 'ผู้ช่วยสอน',
  'aet.instructorCourse.roster.role.instructor': 'ผู้สอน',
  'aet.instructorCourse.roster.status.active': 'ใช้งานอยู่',
  'aet.instructorCourse.roster.status.inactive': 'ไม่ใช้งาน',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'สมาชิกทั้งหมด',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'นักเรียนที่ใช้งานอยู่',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'นักเรียนที่ไม่ใช้งาน',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'ผู้ช่วยสอน',
  'aet.instructorCourse.manageRoster.filter.instructor': 'ผู้สอน',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'ผู้แต่ง:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'วันที่สร้างหลักสูตร:',
  'aet.instructorCourse.noCoursesFound': 'ไม่พบหลักสูตร',
  'aet.instructorCourse.searchNoResultsTitle': 'No courses match “{searchTerm}”',
  'aet.instructorCourse.searchNoResultsDescription': 'Try a different course name.',
  'aet.instructorCourse.clearSearch': 'Clear search',
  'aet.instructorCourse.noCoursesEmptyStateTitle': 'Nothing here yet',
  'aet.instructorCourse.noCoursesEmptyStateDescription': 'Courses you create or are added to will appear here.',
  'aet.instructorCourse.backButton': 'ย้อนกลับ',
  'aet.instructorCourse.selectCourse': 'เลือกหลักสูตร',
  'aet.home.linkedToLms': 'ได้เชื่อมโยงกับ LMS',
  'aet.instructorCourse.courseForm.title.create': 'สร้างหลักสูตร',
  'aet.instructorCourse.courseForm.title.copy': 'คัดลอกหลักสูตร',
  'aet.instructorCourse.courseForm.title.edit': 'ข้อมูลหลักสูตร',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'การตั้งค่า',
  'aet.studentRoster.manageStudentRosterButton': 'จัดการรายชื่อนักเรียน',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'ส่งออกความก้าวหน้าของนักเรียน',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'สถานะ:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'ที่ลงทะเบียน:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'บทบาท:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'เลื่อนขั้น {studentName} หรือไม่',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'ในฐานะผู้ช่วยสอน บุคคลนี้จะสามารถเห็นความก้าวหน้าและผลการเรียนของนักเรียนทุกคนในชั้นเรียนนี้ได้',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'พวกเขายังสามารถจัดการนักเรียนและงานที่มอบหมายได้ แต่จะไม่สามารถลบชั้นเรียนได้',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'เลื่อนขั้นเป็นผู้ช่วยสอน',
  'aet.home.manageRoster.searchPlaceholder': 'ค้นหานักเรียน',
  'aet.home.manageRoster.inactivateButtonLabel': 'ทำเครื่องหมายนักเรียนที่เลือกเป็นไม่ใช้งาน',
  'aet.home.manageRoster.FilterLabel': 'แสดง',
  'aet.home.manageRoster.updatingMessage': 'กำลังอัปเดตรายชื่อ... อาจใช้เวลาไม่กี่นาที',
  'aet.home.courses.search.searchPlaceHolder': 'ค้นหาหลักสูตรของคุณ',
  'aet.courses.emptyStateDescription': 'เริ่มสร้างหลักสูตรของคุณโดยการเลือกตัวเลือกด้านล่าง',
  'nativePromoBanner.continueInBrowser': 'ดำเนินการต่อในเบราว์เซอร์',
  'globalnav.tooltip.hideNavText': 'ซ่อนการเนวิเกต',
  'globalnav.tooltip.showNavText': 'แสดงการเนวิเกต',
  'aet.syllabus.progressTitle': 'กำลังสกัดข้อมูล...',
  'aet.syllabus.progressDesc': 'โปรดรอขณะที่เราประมวลผลโครงร่างหลักสูตรของคุณ',
  'aet.syllabus.uploadInputLabel': 'ลากไฟล์และวางหรือคลิกเพื่ออัปโหลด',
  'aet.syllabus.uploadSyllabusTabLabel': 'อัปโหลดโครงร่างหลักสูตร',
  'aet.syllabus.dateAdjusterTabLabel': 'ตัวปรับข้อมูล',
  'aet.syllabus.addManuallyTabLabel': 'เพิ่มงานที่มอบหมายด้วยตัวเอง',
  'aet.syllabus.addEditLaterText': 'คุณสามารถเพิ่มและแก้ไขงานที่มอบหมายได้ในภายหลัง',
  'aet.syllabus.editAssignmentLabel': 'แก้ไขงานที่มอบหมาย',
  'aet.syllabus.addAssignmentLabel': 'เพิ่มงานที่มอบหมาย',
  'aet.syllabus.assignmentTitleLabel': 'ชื่องานที่มอบหมาย',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'วันครบกำหนด',
  'aet.syllabus.editDueDateLabel': 'แก้ไขวันครบกำหนด',
  'aet.syllabus.chaptersCoveredLabel': 'เลือกบทหรือส่วนที่จะครอบคลุม',
  'aet.syllabus.updateCtaLabel': 'อัปเดตงานที่มอบหมาย',
  'aet.syllabus.addCtaLabel': 'เพิ่มงานที่มอบหมาย',
  'aet.syllabus.uploadLabel': 'อัปโหลด',
  'aet.syllabus.confirmLabel': 'ยืนยัน',
  'aet.syllabus.addContentLabel': 'เพิ่มเนื้อหา',
  'aet.syllabus.addEditContentLabel': 'เพิ่ม/แก้ไขเนื้อหา',
  'aet.syllabus.notPublishedLabel': 'ไม่ได้เผยแพร่',
  'aet.syllabus.updateDatesLabel': 'วันที่อัปเดต',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'วันครบกำหนดของคุณถูกอัปเดต ตรวจสอบ แล้วเผยแพร่',
  'aet.syllabus.coverageDedupe.adjustedContent': 'ข้อมูลบท/ส่วนของคุณถูกอัปเดต ตรวจสอบ แล้วเผยแพร่',
  'aet.syllabus.unassignedCoverageStatus': 'บางบทยังไม่ได้มอบหมาย โปรดมอบหมายก่อนที่คุณจะเผยแพร่',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'ลบงานที่มอบหมายหรือไม่',
  'aet.deleteAssignmentTitleMultiple': 'ลบงานที่มอบหมายหรือไม่',
  'aet.deleteAssignmentWarning': 'การดำเนินการนี้ไม่สามารถยกเลิกได้ และข้อมูลการส่งงานและข้อมูลนักเรียนที่เกี่ยวข้องทั้งหมดจะไม่ปรากฏให้เห็นอีกต่อไป',
  'aet.deleteAssignmentKeepCTA': 'เก็บงานที่มอบหมายไว้',
  'aet.deleteAssignmentDeleteCTA': 'ลบ',
  'aet.assignments.loadingAsset': 'กำลังโหลดสินทรัพย์...',
  'aet.assignments.addToDate': 'เพิ่มไปยังวันที่',
  'aet.assignments.previewAsStudent': 'ดูตัวอย่างเป็นฐานะนักเรียน',
  'aet.assignments.questionsAndTopics': 'คำถามและหัวข้อ',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'เสร็จแล้ว',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'วันครบกำหนด',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'คำถามทั้งหมด',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'คำถาม {count} จาก {total}',
  'aet.assignments.questionsAndTopicsModal.sectionSelectLabel': 'Select a section',
  'aet.assignments.publishToStudents': 'เผยแพร่ให้กับนักเรียน',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'เพิ่มวันที่',
  'aet.assistedSchedule.addToAssignmentModalTitle': 'Add to assignment',
  'aet.assistedSchedule.addToAssignmentModalEmptyLabel': 'No content yet',
  'aet.doneLabel': 'เสร็จแล้ว',
  'aet.assignments.dueDateLabel': 'วันครบกำหนดของงานที่มอบหมาย',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now:',
  'aet.onboarding.getStarted.manualSetup.title': 'ตั้งค่าด้วยตัวเอง',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.manualSetup.ctaLabel': 'Create manually',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Weekly schedule',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Pick a due day that repeats all term, then drag chapters into each week',
  'aet.onboarding.getStarted.assistedScheduling.ctaLabel': 'Build schedule',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Turn assigned reading into active learning',
  'aet.onboarding.promotion.feature.1': 'Quickly create assignments with embedded questions, plus optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'ใช้ข้อมูลเชิงลึกแบบเรียลไทม์เพื่อระบุช่องว่างทางการเรียนรู้ เพื่อให้คุณสามารถดำเนินการแก้ไขได้อย่างมั่นใจตั้งแต่เนิ่นๆ',
  'aet.onboarding.promotion.feature.3': 'นักเรียนจะได้รับการสนับสนุนมากขึ้นด้วยคำติชมที่ตรงเป้าหมายและระบบ AI ของ Pearson ที่ผสานรวมอยู่ภายใน',
  'aet.onboarding.getStarted.previewQuestions.prompt': 'Want to see what’s available?',
  'aet.onboarding.getStarted.previewQuestions.link': 'Preview all questions',
  'aet.questionPreview.title': 'Preview questions',
  'aet.questionPreview.chapterSelectLabel': 'Select chapter',
  'aet.questionPreview.questionLabel': 'question',
  'aet.questionPreview.questionsLabel': 'questions',
  'aet.questionPreview.correctAnswer': 'Correct answer',
  'aet.questionPreview.noQuestions': 'No questions are available for this chapter.',
  'aet.assistedSchedule.pageTitle': 'Weekly schedule',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set up a weekly schedule',
  'aet.assistedSchedule.sectionDescription': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysLabel': 'Have assignments due every',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose one or more days of the week',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.viewQuestions': 'View questions',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Start assignments by',
  'aet.assistedSchedule.endDateLabel': 'End assignments by',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.autoNameAssignmentsLabel': 'Automatically name assignments based on content',
  'aet.assistedSchedule.autoNameAssignmentsInstruction': 'Assignment names will be generated from the content.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assistedSchedule.addNewLabel': 'Add new',
  'aet.assistedSchedule.addToNewAssignmentLabel': 'Add to new assignment',
  'aet.assistedSchedule.saveAsDraftLabel': 'Save as draft',
  'aet.assistedSchedule.saveAndPublishLabel': 'Save and publish',
  'aet.assignments.allCaughtUpDescription': 'ไม่มีงานที่มอบหมายครบกำหนดสัปดาห์นี้',
  'aet.assignments.progressTitle': 'ความคืบหน้า',
  'aet.assignments.performanceTitle': 'ความมั่นใจ',
  'aet.assignments.completionTitle': 'การเสร็จสมบูรณ์',
  'aet.assignments.statusTitle': 'สถานะ',
  'aet.assignments.addTooltip': 'เพิ่มงานที่มอบหมาย',
  'aet.assignments.deleteTooltip': 'ลบงานที่มอบหมายที่เลือก',
  'aet.assignments.selectToDeleteLabel': 'เลือกและลบโหมด',
  'aet.assignments.bulkEditTooltip': 'แก้ไขงานที่มอบหมายแบบกลุ่ม',
  'aet.assignments.title': 'งานที่มอบหมาย',
  'aet.assignments.assignmentTitle': 'งานที่มอบหมาย',
  'aet.assignments.dueDate': 'วันครบกำหนด',
  'aet.tabular.searchPlaceholder.assignments': 'ค้นหางานที่มอบหมาย',
  'aet.tabular.searchPlaceholder.students': 'ค้นหานักเรียน',
  'aet.tabular.searchPlaceholder.questions': 'ค้นหาคำถาม',
  'aet.assignemnts.columnDueDateInfoTooltip': 'นักเรียนอย่างน้อยหนึ่งคนได้รับการขยายวันครบกำหนดสำหรับงานที่มอบหมายทั้งหมด',
  'aet.assignemnts.singleDueDateInfoTooltip': 'นักเรียนอย่างน้อยหนึ่งคนได้รับการขยายวันครบกำหนดสำหรับงานที่มอบหมายนี้',
  'aet.assignemnts.masterDueDateInfoTooltip': 'นักเรียนอย่างน้อยหนึ่งคนได้รับอนุญาตการขยายวันครบกำหนด มองหาไอคอนข้อมูลเพื่อระบุงานที่มอบหมายเหล่านี้',
  'aet.home.loading': 'กำลังโหลด...',
  'aet.home.errorFetchingAssignments': 'ข้อผิดพลาดในการดึงงานที่มอบหมาย',
  'aet.home.dueThisWeekTitle': 'ครบกำหนดสัปดาห์นี้',
  'aet.home.allCaughtUpTitle': 'คุณได้ตามทันแล้ว!',
  'aet.home.allCaughtUpDescription': 'ไม่มีงานที่มอบหมายครบกำหนดสัปดาห์นี้',
  'aet.home.suggestedRemediationTitle': 'การทบทวนที่แนะนำโดย Study Prep',
  'aet.home.noSuggestedRemediationTitle': 'ไม่มีเนื้อหาการทบทวนที่แนะนำ',
  'aet.home.noSuggestedRemediationDescription': 'ตรวจสอบอีกครั้งหลังจากงานที่มอบหมายถัดไปของคุณ',
  'aet.home.assignmentIncludesTitle': 'งานที่มอบหมายรวม',
  'aet.home.sectionsLabel': 'บท',
  'aet.home.questionsCount': '{count} คำถาม',
  'aet.home.dueLabel': 'ครบกำหนด: {dueDate}',
  'aet.home.due': 'ครบกำหนด:',
  'aet.home.progressCompletedLabel': 'เสร็จสมบูรณ์',
  'aet.home.progressCompletedPastDueLabel': 'เสร็จสมบูรณ์โดยเลยกำหนด',
  'aet.home.progressInProgressLabel': 'กำลังคืบหน้า',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'ไม่ได้เริ่มต้น',
  'aet.home.progressCountOfTotal': '{count} ของ {total}',
  'aet.home.NotAttemptedLabel': 'ไม่ได้ลองทำ',
  'aet.home.questionsTotalLabel': 'คำถามทั้งหมด',
  'aet.home.progressCompletedOnTimeLabel': 'เสร็จสมบูรณ์ตามกำหนดเวลา',
  'aet.home.segmentGreatLabel': 'เยี่ยม',
  'aet.home.segmentGettingThereLabel': 'โอเค',
  'aet.home.segmentNeedsReviewLabel': 'ต้องทำงาน',
  'aet.home.segmentOkayLabel': 'โอเค',
  'aet.home.editAssignmentTooltip': 'แก้ไขงานที่มอบหมาย',
  'aet.home.deleteAssignmentTooltip': 'ลบงานที่มอบหมาย',
  'aet.home.viewDetailsButton': 'ดูรายละเอียด',
  'aet.home.viewAsStudentButton': 'ดูเป็นนักเรียน',
  'aet.home.welcomeButtonText': 'เริ่มต้นกันเลย →',
  'aet.review.emptyStateTitle': 'ไม่มีสิ่งใดให้ทบทวน',
  'aet.review.emptyStateDescription': 'ตรวจสอบอีกครั้งหลังจากงานที่มอบหมายถัดไปของคุณ',
  'aet.dashboard.tabs.upNext': 'ถัดไป',
  'aet.dashboard.tabs.welcome': 'ยินดีต้อนรับ',
  'aet.dashboard.tabs.assignments': 'งานที่มอบหมาย',
  'aet.dashboard.tabs.review': 'ทบทวน',
  'aet.dashboard.tabs.studentRoster': 'นักเรียน',
  'aet.dashboard.classSchedule': 'ตารางเวลาของชั้นเรียน:',
  'aet.syllabus.dueTimeLabel': 'เวลาครบกำหนด',
  'hero.accessEducatorGuides': 'เข้าถึงคำแนะนำของนักการศึกษา',
  'aet.assignment.save': 'บันทึก',
  'aet.assignment.finish': 'เสร็จสิ้น',
  'aet.assignment.saveAndAdd': 'บันทึกและเพิ่มอีก',
  'aet.assignment.delete': 'ลบ',
  'aet.assignment.saveAndClose': 'บันทึกและปิด',
  'aet.studentRoster.title': 'นักเรียน',
  'aet.studentRoster.titlev1': 'นักเรียน',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'วันครบกำหนด',
  'aet.studentRoster.dueDateAdjustment.option.0': 'มาตรฐาน',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 วัน',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 วัน',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 วัน',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 สัปดาห์',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 สัปดาห์',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'วันสุดท้ายของชั้นเรียน',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} of {total} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '{skippedCount} assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.success.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.single': 'New due dates have been added to <b>{assignmentTitle}</b>.',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.multiple': 'New due dates have been added to multiple assignments.',
  'aet.bulkEdit.bulkSplitInstruction': 'เราจะแบ่งย่อยงานที่มอบหมายเท่าๆ กัน',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'การครบกำหนดของงานที่มอบหมายแรก',
  'aet.bulkEdit.lastAssignmentDue': 'การครบกำหนดของงานที่มอบหมายสุดท้าย',
  'aet.bulkEdit.assignmentsDueDays': 'คุณต้องการให้ส่งงานที่มอบหมายภายในวันใด',
  'aet.bulkEdit.addEditLaterText': 'เราใช้ AI ในการสร้างงานที่มอบหมาย คุณสามารถเพิ่มและแก้ไขงานที่มอบหมายได้ตลอดเวลา',
  'aet.bulkEdit.monday': 'วันจันทร์',
  'aet.bulkEdit.tuesday': 'วันอังคาร',
  'aet.bulkEdit.wednesday': 'วันพุธ',
  'aet.bulkEdit.thursday': 'วันพฤหัสบดี',
  'aet.bulkEdit.friday': 'วันศุกร์',
  'aet.bulkEdit.saturday': 'วันเสาร์',
  'aet.bulkEdit.sunday': 'วันอาทิตย์',
  'aet.toast.assignmentCreated.title': '1 assignment created',
  'aet.toast.assignmentCreated.title.multiple': '{count} assignments created',
  'aet.toast.assignmentCreated.single': 'Assignment was named <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentCreated.multiple': 'Assignment names were also added.',
  'aet.toast.assignmentUpdated.title': 'อัปเดตสำเร็จ',
  'aet.toast.assignmentUpdated.title.single': '1 assignment updated',
  'aet.toast.assignmentUpdated.single': 'Your changes have been saved to <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentUpdated.multiple': '{count} งานที่มอบหมายถูกอัปเดตแล้ว',
  'aet.toast.assignmentPublished.single': '{count} assignment published',
  'aet.toast.assignmentPublished.multiple': '{count} assignments published',
  'aet.toast.assignmentPublished.subtitle': 'ไม่สามารถแก้ไขเนื้อหางานที่มอบหมายได้จนกว่านักเรียนจะเริ่มทำงาน',
  'aet.toast.assistedScheduleCreated.single': '{count} Assignment created!',
  'aet.toast.assistedScheduleCreated.multiple': '{count} Assignments created!',
  'aet.toast.assistedScheduleCreated.subtitle': 'Default assignment titles were updated based on content.',
  'aet.toast.assistedSchedulePublished.single': '{count} Assignment published!',
  'aet.toast.assistedSchedulePublished.multiple': '{count} Assignments published!',
  'aet.toast.viewAssignment': 'ดูงานที่มอบหมาย',
  'aet.toast.viewAssignments': 'ดูงานที่มอบหมาย',
  'aet.welcome.title': 'หนังสือเรียนอิเล็กทรอนิกส์ของ Pearson ของคุณเชื่อมโยงกับหลักสูตร LMS ของคุณเรียบร้อยแล้ว',
  'aet.welcome.LMSAccounTitle': 'สำรวจข้อมูลเชิงลึก',
  'aet.welcome.LMSAccounDescription': 'ตรวจสอบให้แน่ชัดว่านักเรียนในชั้นเรียนของคุณมีปัญหาในหัวข้อใดบ้าง',
  'aet.welcome.createAssignmentsTitle': 'สร้างงานที่มอบหมาย',
  'aet.welcome.createAssignmentsDescription': 'มอบหมายบทด้วยตนเองหรือโดยการอัปโหลดโครงร่างหลักสูตรของคุณ',
  'aet.welcome.progressViewTitle': 'ติดตามประสิทธิภาพใน LMS ของคุณ',
  'aet.welcome.progressViewDescription': 'เลือกการตั้งค่าการซิงค์เกรดในหลักสูตร LMS ของคุณ',
  'aet.assignmentDetails.noAssignmentFound': 'ไม่พบงานที่มอบหมาย',
  'aet.assignments.loadingErrorTitle': 'ไม่สามารถโหลดงานที่มอบหมายในขณะนี้',
  'aet.assignments.loadingErrorDescription': 'ลองรีเฟรชหรือตรวจสอบอีกครั้งในภายหลัง',
  'aet.assignmentStudentDetails.noDataFound': 'ยังไม่มีข้อมูล',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'ไม่มีนักเรียนได้ลงทะเบียน',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'นักเรียนจะเข้าร่วมชั้นเรียนของคุณเมื่อพวกเขาซื้อหนังสือเรียนอิเล็กทรอนิกส์',
  'aet.home.editAssignmentTooltipDisabled': 'ไม่สามารถแก้ไข: งานของนักเรียนกำลังคืบหน้า',
  'aet.home.deleteAssignmentTooltipDisabled': 'ไม่สามารถลบ: งานของนักเรียนกำลังคืบหน้า',
  'aet.home.StudentDetails.questions': 'คำถาม',
  'aet.home.StudentDetails.attempts': 'จำนวนครั้ง',
  'aet.home.StudentDetails.comprehension': 'ความมั่นใจ',
  'hero.titleInfo.tooltip': 'ข้อมูลหนังสือ',
  'aet.home.publishAssignments': 'เผยแพร่งานที่มอบหมายทั้งหมด',
  'aet.assignments.saveScheduleAsDraft': 'บันทึกกำหนดการเป็นแบบร่าง',
  'aet.assignments.reviewBeforePublishAlert': 'ตรวจสอบงานที่มอบหมายของคุณ จากนั้นเผยแพร่งานที่มอบหมายของคุณเพื่อให้เหล่านักเรียนมองเห็นได้',
  'aet.assignments.copiedCoursePublishAlert': 'เพิ่มวันที่ไปยังงานที่มอบหมายของคุณ แล้วเผยแพร่งานที่มอบหมายของคุณเพื่อให้เหล่านักเรียนมองเห็นได้',
  'aet.assignments.allSetPublishAlert': 'พร้อมแล้วใช่ไหม เผยแพร่งานที่มอบหมายของคุณเพื่อให้เหล่านักเรียนมองเห็นได้',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'เนื้อหาบางส่วนสร้างขึ้นโดยใช้ AI โดยอ้างอิงจากเนื้อหาการเรียนรู้ของ Pearson แม้ว่า Pearson จะมีกระบวนการตรวจสอบความถูกต้องของผลลัพธ์ แต่ AI เชิงสร้างใหม่อาจยังคงให้ข้อมูลที่ไม่แม่นยำเกี่ยวกับบุคคล สถานที่ หรือข้อเท็จจริงได้',
  'aet.home.bulkEditTitle': 'แก้ไขงานที่มอบหมายแบบกลุ่ม',
  'aet.home.bulkEditSubtitle': 'ทำการแก้ไขโครงร่างหลักสูตรของคุณให้เรียบร้อย แล้วอัปโหลดกลับมาที่นี่ งานที่มอบหมายและวันครบกำหนดจะได้รับการอัปเดตให้ตรงกัน',
  'aet.home.createAssignmentTitle': 'สร้างงานที่มอบหมาย',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'รวมในงานที่มอบหมายอื่น',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'บางส่วนถูกรวมในงานที่มอบหมายอื่น',
  'aet.welcome.welcome.Title': 'ยินดีต้อนรับ!',
  'aet.home.student.roaster.ProgressTitle': 'การเสร็จสมบูรณ์รวม',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'กลับมาตรวจสอบอีกครั้งเมื่อนักเรียนเริ่มทำงานที่มอบหมาย',
  'aet.home.whatDueThisWeekTitle': 'นี่คือรายการครบกำหนดสัปดาห์นี้',
  'aet.assignments.edit.errorTitle': '{count} งานที่มอบหมายมีข้อผิดพลาด',
  'aet.assignments.edit.errorSubTitle': 'ไม่สามารถเผยแพร่งานที่มอบหมายที่มีมีข้อผิดพลาดได้ แก้ไขหรือเผยแพร่โดยไม่มีงานที่มอบหมาย',
  'aet.assignments.edit.publishAnyway': 'เผยแพร่เลย',
  'aet.assignments.edit.editAssignments': 'แก้ไขงานที่มอบหมาย',
  'aet.assignments.edit.validationInfoToolTip': 'แก้ไขงานที่มอบหมายเพื่อขจัดข้อผิดพลาด',
  'aet.assignments.error.assignmentCreated.title': 'งานที่มอบหมายทั้งหมดมีข้อผิดพลาด',
  'aet.assignments.error.assignmentCreated.description': 'ไม่สามารถเผยแพร่งานที่มอบหมายได้ แก้ไขหรือลองใช้โครงร่างหลักสูตรอื่น',
  'aet.assignments.error.uploadSyllabus': 'อัปโหลดโครงร่างหลักสูตร',
  'aet.assignments.error.editAssignments': 'แก้ไขงานที่มอบหมาย',
  'aet.mondly.title': 'ภาษา',
  'aet.studentRoster.errorState.title': 'รายชื่อนักเรียนไม่พร้อมใช้งาน',
  'aet.studentRoster.errorState.description': 'เราไม่สามารถโหลดรายชื่อนักเรียนได้ ลองรีเฟรชหรือตรวจสอบอีกครั้งในภายหลัง',
  'aet.assignments.sectionLabel': 'ส่วน',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.tags.dueNext': 'Due next',
  'aet.assignments.tags.pastDue': 'Past due',
  'aet.assignments.completionLabel': 'answered',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'คำถาม',
  'aet.assignments.assignmentsLabel': 'งานที่มอบหมาย',
  'aet.assignments.performanceProgressBar': 'แถบความคืบหน้าของประสิทธิภาพ',
  'aet.assignments.completionProgressBar': 'แถบความคืบหน้าของเสียการเสร็จสมบูรณ์',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'คุณแน่ใจหรือไม่ว่าต้องการลบงานที่มอบหมายนี้',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'คุณแน่ใจหรือไม่ว่าต้องการลบงานที่มอบหมายเหล่านี้',
  'aet.home.nextAssignmentTitle': 'งานที่มอบหมายถัดไป',
  'aet.home.courseSettings': 'การตั้งค่าหลักสูตร',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'ทรัพยากรหนังสือเรียนอิเล็กทรอนิกส์ทรัพยากร Pearson+',
  'aet.home.etextbookInformation': 'ข้อมูลหนังสือเรียนอิเล็กทรอนิกส์',
  'aet.multiple.deleteAssignmentKeepCTA': 'เก็บงานที่มอบหมายไว้',
  'aet.syllabus.processingText.header': 'เรากำลังจัดเรียงเอกสารอ่านประกอบสำหรับชั้นเรียนของคุณ ซึ่งจะใช้เวลาเพียงสักครู่',
  'aet.syllabus.processingText.uploading': 'กำลังอัปโหลดเอกสารของคุณ',
  'aet.syllabus.processingText.activating': 'กำลังเปิดใช้งานส่วนประกอบ AI',
  'aet.syllabus.processingText.extracting': 'กำลังสกัดข้อมูลงานที่มอบหมายของการอ่าน',
  'aet.syllabus.processingText.mapping': 'กำลังแมปกับเนื้อหาหนังสือเสียง',
  'aet.syllabus.processingText.finishing': 'กำลังเสร็จสิ้นการทำงาน',
  'aet.syllabus.uploadErrorMessage': 'ตรวจสอบให้แน่ใจว่าไฟล์ PDF หรือ .docx ของคุณมีขนาดไม่เกิน 10MB และการเชื่อมต่ออินเทอร์เน็ตของคุณเสถียร',
  'aet.syllabus.uploadNoAssignmentsMessage': 'ไม่พบงานที่มอบหมายของการอ่าน',
  'aet.syllabus.uploadNoAssignmentsDescription': 'เราไม่สามารถดึงงานที่มอบหมายของการอ่านจากไฟล์นี้ได้ คุณสามารถเพิ่มด้วยตนเอง',
  'aet.syllabus.uploadFailedRetryCTA': 'ลองอีกครั้ง',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'ดับเบิลคลิกเพื่อดูว่าโครงร่างหลักสูตรของคุณมี<qualities a syllabus should have for this to work> หรือไม่ แล้วลองอีกครั้ง หรือลองสร้างงานที่มอบหมายด้วยตัวเอง',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'การสร้างด้วยตัวเอง',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'เกิดข้อผิดพลาดบางอย่าง',
  'aet.syllabus.uploadModal.genericFailure.body1': 'เราไม่สามารถอัปโหลดและดำเนินการกับโครงร่างหลักสูตรได้',
  'aet.syllabus.uploadModal.genericFailure.body2': 'ตรวจสอบการเชื่อมต่อของคุณ แล้วลองอีกครั้ง หรือลองสร้างงานที่มอบหมายด้วยตัวเอง',
  'aet.syllabus.uploadModal.successTotal.title': 'พร้อมสำหรับตรวจสอบ',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'พร้อมสำหรับตรวจสอบ',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'ตรวจสอบงานที่มอบหมาย',
  'aet.syllabus.selectChapterWithQuestions': 'เลือกบทที่มีคำถาม',
  'preferenceSetting.subTitle': 'การตั้งค่าเหล่านี้จะเป็นค่าเริ่มต้นสำหรับนักเรียนทุกคนในหลักสูตรนี้',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'การโต้ตอบของ AI',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'เปิดใช้งานเครื่องมือการเรียนด้วย AI และสรุปข้อมูลด้วย AI ในผลการค้นหา',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'แสดงทรัพยากรของ Study Prep ที่เกี่ยวข้องกับหนังสือเล่มนี้',
  'aet.syllabus.footer': 'การสร้างงานที่มอบหมายขับเคลื่อนโดย AI',
  'aet.dashboard.footerDialogDeatils': 'Generative AI ถูกนำมาใช้เพื่อสร้างคำถามสำหรับงานที่มอบหมายโดยอิงจากสื่อการเรียนรู้ของ Pearson แม้ว่า Pearson จะมีกระบวนการตรวจสอบความถูกต้องของผลลัพธ์ แต่ AI เชิงสร้างใหม่อาจยังคงให้ข้อมูลที่ไม่แม่นยำเกี่ยวกับบุคคล สถานที่ หรือข้อเท็จจริงได้ นอกจากนี้ AI ยังถูกนำมาใช้ในการจัดกลุ่มเนื้อหาเป็นงานที่มอบหมาย โดยอิงตามหลักสูตรและ/หรือตารางเรียนที่คุณให้มา',
  'aet.review.footer': 'ได้สร้างโดยใช้ AI',
  'aet.footerCard.dismiss': 'ยกเลิก',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Study Prep เป็นเครื่องมือเสริมที่ช่วยสนับสนุนการเรียนรู้ โดยจัดเตรียมวิดีโอและปัญหาฝึกหัดที่ออกแบบมาเฉพาะสำหรับหลักสูตรนี้ให้กับนักเรียน',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'นักเรียนที่แผนการเข้าถึงไม่รวมถึง Study Prep อาจถูกขอให้สมัครใช้งานเพื่อใช้งานแหล่งข้อมูล Study Prep ต่อไป',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'นักเรียนที่ซื้อ Study Prep ไปแล้วจะไม่ได้รับผลกระทบจากการตั้งค่านี้',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'เรียนรู้เพิ่มเติมเกี่ยวกับประโยชน์ของ Study Prep',
  'aet.home.viewCourseId': 'ดู ID หลักสูตร',
  'aet.home.copy': 'คัดลอก',
  'aet.home.copied': 'คัดลอกแล้ว',
  'aet.home.courseLabel': 'ID หลักสูตร:',
  'schoolInfoCard.addUniversity': 'เพิ่มโรงเรียน',
  'schoolInfoCard.title': 'ข้อมูลโรงเรียน',
  'schoolInfoCard.titleV1': 'บอกเราเกี่ยวกับหลักสูตรของคุณ',
  'schoolInfoCard.cta': 'เริ่มต้นกันเลย',
  'schoolInfoCard.pickInstitution': 'เลือกโรงเรียน',
  'schoolInfoCard.addUniversityTitle': 'เพิ่มโรงเรียนของคุณ',
  'schoolInfoCard.addUniversitySubtitle': 'การรู้ข้อมูลเกี่ยวกับโรงเรียนและหลักสูตรของคุณ ทำให้เราสามารถแนะนำสื่อการเรียนที่เหมาะสมที่สุดให้กับคุณได้',
  'schoolInfoCard.searchPlaceholder': 'ค้นหาโรงเรียนของคุณ...',
  'schoolInfoCard.skip': 'ข้ามขั้นตอนนี้',
  'schoolInfoCard.nextStep': 'ขั้นตอนถัดไป',
  'schoolInfoCard.notInList': 'โรงเรียนของฉันไม่อยู่ในรายการ',
  'schoolInfoCard.noResults': 'ไม่พบโรงเรียนที่ตรงกับการค้นหาของคุณ',
  'schoolInfoCard.noResultsHeading': 'ไม่พบโรงเรียนของคุณ',
  'schoolInfoCard.noResultsInstruction': 'ป้อนชื่อเต็มด้านล่าง',
  'schoolInfoCard.noResultsInputPlaceholder': 'ชื่อโรงเรียน',
  'schoolInfoCard.addInstitutionLabel': 'เพิ่มโรงเรียนนี้',
  'aet.assignments.assignmentTitlePlaceholder': 'ป้อนชื่อเรื่อง',
  'aet.assignments.titleValidation.titleRequired': 'ต้องระบุชื่องานที่มอบหมาย',
  'aet.assignments.titleValidation.titleTooLong': 'ชื่องานที่มอบหมายต้องไม่เกิน{0} ตัวอักขระ',
  'aet.assignments.titleValidation.titleInvalidChar': 'ชื่องานที่มอบหมายมีตัวอักขระที่ไม่รองรับ',
  'aet.assignments.titleValidation.titleDuplicate': 'ชื่องานที่มอบหมายที่มีอยู่แล้ว',
  'aet.syllabus.timeZoneLabel': 'เขตเวลา',
  'aet.review.reviewReadingFromAssignments': 'ทบทวนการอ่านจากงานที่มอบหมาย',
  'aet.assignments.chaptersLabel': 'บท',
  'menu.myAccount.subTitle': 'สถาบันของคุณออกอากาศอยู่ที่นี่',
  'menu.myAccount.subTitleNotAvailable': 'คุณสามารถเพิ่มสถาบันของคุณที่นี่ในภายหลังได้ตลอดเวลา',
  'schoolInfoCard.toastMessage': 'บันทึกมหาวิทยาลัยแล้ว',
  'aet.review.threeDotMenu.askAI': 'ถาม AI',
  'aet.home.suggestedRemediationSubtitle': 'ดูวิดีโอที่เกี่ยวข้องและฝึกฝนเพื่อเพิ่มพูนความรู้ในหัวข้อต่างๆ ของหลักสูตร',
  'aet.home.laggedQuestionLabel': 'คำถามที่ใส่ค่าสถานะ',
  'aet.home.correctAnswer': 'คำตอบถูกต้อง',
  'aet.home.incorrectAnswer': 'คำตอบไม่ถูกต้องส่วนใหญ่',
  'aet.home.behaviourTrendsLabel': 'ข้อมูลเชิงลึกของคำถาม',
  'aet.home.strugglingStudentsLabel': 'นักเรียนที่มีปัญหา',
  'aet.home.patternsInStudensAiLabel': 'รูปแบบในการใช้ AI ของนักเรียน',
  'aet.home.questionLabel': 'คำถาม',
  'aet.home.studentAskingSimilarQuestions': 'นักเรียนได้ถามคำถามที่ึคล้ายกัน',
  'aet.home.assignmentDifficultQuestions': 'คำถามที่ยาก',
  'aet.home.behaviorTrends': 'ข้อมูลเชิงลึกของคำถาม',
  'aet.home.behaviors': 'ตัวบ่งชี้ประสิทธิภาพ',
  'aet.home.mostDifficultTopics': 'คำถามที่ยากที่สุด',
  'aet.home.commentsFromStudentLabel': 'ความคิดเห็นจากนักเรียน',
  'aet.home.disregard': 'ไม่สนใจ',
  'aet.home.reportAsInaccurate': 'รายงานเป็นไม่แม่นยำ',
  'aet.home.Flagged': 'ติดค่าสถานะแล้ว',
  'aet.home.reportQuestionTitle': 'คำถามสำหรับรายงาน',
  'aet.home.reportQuestionLabel': 'คำถามนี้มีข้อผิดพลาดตรงไหน',
  'aet.home.showComments': 'แสดงความคิดเห็น',
  'aet.home.studentReports': 'รายงานของนักเรียน',
  'aet.home.placeholderText': 'โปรดอธิบาย...',
  'aet.home.reportQuestion.notRelevant': 'ไม่เกี่ยวข้อง',
  'aet.home.reportQuestion.notCorrect': 'ไม่ถูกต้อง',
  'aet.home.reportQuestion.unsafe': 'ไม่ปลอดภัย/มีอันตราย',
  'aet.home.reportQuestion.somethingElse': 'อย่างอื่น',
  'aet.home.StudentDetails.assistedByAI': 'ช่วยเหลือโดย AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'ไม่มีนักเรียนพบปัญหาในขณะนี้',
  'aet.home.strugglingStudents.emptyStateDescription': 'กลับมาตรวจสอบในภายหลัง',
  'aet.home.overallStatus.excelling': 'ยอดเยี่ยม',
  'aet.home.overallStatus.fallingBehind': 'ล้าหลัง',
  'aet.home.overallStatus.keepingUp': 'จงทำต่อไป',
  'aet.home.showOnlyDifficultQuestionsLabel': 'แสดงเฉพาะ "คำถามที่ยาก"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'แสดงเฉพาะ "นักเรียนที่มีปัญหา"',
  'aet.home.viewQuestionInAssignment': 'ดูคำถามในงานที่มอบหมาย',
  'aet.home.insightRisk.incorrectFirstAttempts': 'ไม่ถูกต้องในการลองครั้งแรก',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'จำนวนครั้งไม่ถูกต้องหลายครั้ง',
  'aet.home.insightRisk.lowConfidence': 'ความมั่นใจต่ำ',
  'aet.home.insightRisk.mediumConfidence': 'ความมั่นใจปานกลาง',
  'aet.home.insightRisk.lowEngagement': 'การมีส่วนร่วมต่ำ',
  'aet.home.insightRisk.countOfStudents': 'นักเรียน {count} จากทั้งหมด {total} คน',
  'aet.home.insightRisk.na': 'ไม่เกี่ยวข้อง',
  'aet.home.strugglingStudentsHereLabel': 'นักเรียนที่มีปัญหาที่นี่',
  'aet.home.insightRisk.didNotAttempt': 'ไม่ได้ลองทำ',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'การรวมระบบ LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.',
  'aet.unlinkCourse.title': 'Unlink Pearson and [LMS] courses?',
  'aet.unlinkCourse.warning.accessInfoBeforePearson': 'Your Pearson course will be unlinked from your [LMS] course. You can still access the Pearson course by signing into ',
  'aet.unlinkCourse.warning.pearsonLinkLabel': 'Pearson',
  'aet.unlinkCourse.warning.accessInfoAfterPearson': ' with your linked account.',
  'aet.unlinkCourse.warning.relinkInfo': 'If no students are enrolled in the Pearson course you’re unlinking, you can link it again with the same [LMS] course.',
  'aet.unlinkCourse.beforeContinueHeading': 'Before you continue:',
  'aet.unlinkCourse.beforeContinueItem': 'If you link your [LMS] course with a different Pearson course, delete all Pearson grades from your [LMS] gradebook and any areas or modules in your LMS course. Otherwise, your [LMS] course may have duplicate grades.',
  'aet.unlinkCourse.inProgressCta': 'Unlinking...',
  'aet.unlinkCourse.okCta': 'OK',
  'aet.unlinkCourse.success.title': 'Unlink successful',
  'aet.unlinkCourse.success.heading': 'Your course has been unlinked from your LMS',
  'aet.unlinkCourse.success.descriptionBeforePearson': 'You can still access the course by signing into ',
  'aet.unlinkCourse.success.descriptionAfterPearson': ' with your Pearson account.',
  'aet.unlinkCourse.failure.title': 'Couldn\'t unlink course',
  'aet.unlinkCourse.failure.paragraph1': 'Your course couldn\'t be unlinked from your LMS. Wait a few minutes and try again.',
  'aet.unlinkCourse.failure.paragraph2': 'If the problem continues, contact Pearson Support.'
};

export default th;
